export default {
  'dynamic-bundle:personal-box:message:no-products':
    'There are currently no suitable recommendations for you in this category.',
  'dynamic-bundle:personal-box:message:no-category': 'No {category} selected',
  'dynamic-bundle:personal-box:title:with-pet': `Personalized trial box for {suffix}`,
  'dynamic-bundle:personal-box:title': `Personalized trial box {suffix}`,
  'dynamic-bundle:personal-box:default-title': `Personalized trial box`,
  'dynamic-bundle-controller:for': 'for',
  'dynamic-bundle:personal-box:with': 'with',
  'dynamic-bundle-controller:with:allergies': 'Exclude ingredients:',
  'dynamic-bundle-controller:with:preferences': 'Prefer ingredients:',
  'dynamic-bundle:usp:personalized:dog': "Tailored to your dog's needs & preferences",
  'dynamic-bundle:usp:personalized:cat': "Tailored to your cat's needs & preferences",
  'dynamic-bundle:usp:test-multiple': 'Easily try different products',
  'dynamic-bundle:usp:fast-start': 'Start quickly – zero effort for you',
  'dynamic-bundle:bundle-preview:image-alt': 'Product image',
  'dynamic-bundle:button:see-details': 'See details',
  'dynamic-bundle:button:add-to-cart': 'Add to cart',
  'dynamic-bundle:product:ingredients': 'Ingredients',
  'dynamic-bundle:product:no-content': 'No content provided',
  'dynamic-bundle-controller:price:title': 'Price of your box',
  'dynamic-bundle-controller:button:add-to-cart': 'Add to cart',
  'dynamic-bundle-controller:error:not-enough-products':
    'You need {min} products to create your box',
  'dynamic-bundle-controller:tooltip:warning:max-products-exceeded':
    'No other matching products available',
  'dynamic-bundle-controller:tooltip:warning:increased': 'Product added',
  'dynamic-bundle-controller:tooltip:warning:decreased': 'Product removed',
  'dynamic-bundle:illustration': 'Dynamic Bundle Product Illustration',
  'dynamic-bundle:subscription-overlay:title': 'Spar-Abo: convenient & relaxed',
  'dynamic-bundle:subscription-overlay:benefit:pause-cancel': 'Pause or cancel any time',
  'dynamic-bundle:subscription-overlay:benefit:flexible-products': 'Adjust the products flexibly',
  'dynamic-bundle:subscription-overlay:benefit:discount': '{discount}% off every delivery',
  'dynamic-bundle:subscription-overlay:price:this-delivery': 'This delivery',
  'dynamic-bundle:subscription-overlay:price:further-deliveries': 'Every further delivery',
  'dynamic-bundle:subscription-overlay:price:interval': '(every {weeks} weeks)',
  'dynamic-bundle:subscription-overlay:button:subscribe': 'Add to cart with Spar-Abo',
  'dynamic-bundle:subscription-overlay:button:one-time': 'Buy once',
  'personalised-bundle:headline': 'Still unsure? Start with your personalised trial pack',
  'personalised-bundle:subline':
    "{count} recipes, perfectly tailored to your dog's needs & preferences",
  'personalised-bundle:cta': 'Add trial pack to cart',
  'personalised-bundle:image-alt': 'Personalised trial pack for your dog',
};
